export default __webpack_public_path__ + "static/media/edit_bola.4939b966.png";